export const ENVIRONMENT_AUTH_DETAILS = {
    prd: {
        clientId: '0oa71l0qjr9dmPn1v4x7',
        issuerPath: 'https://apps.motional.com/oauth2/',
        issuerId: 'aus71kv8xktOUzCOP4x7',
    },
    comm: {
        clientId: '0oado1gorqubzyoiA4x7',
        issuerPath: 'https://apps.motional.com/oauth2/',
        issuerId: 'ausdo1ds94iarNz4F4x7',
    },
    hil: {
        clientId: '0oas7xueaoac4sySY4x7',
        issuerPath: 'https://motional.okta.com/oauth2/',
        issuerId: 'aus71kv8xktOUzCOP4x7',
    },
    dev: {
        clientId: '0oa3k66s07vz97uqG1d7',
        issuerPath: 'https://motional.oktapreview.com/oauth2/',
        issuerId: 'aus3k64vnhcspKf3r1d7',
    },
};
//# sourceMappingURL=auth.js.map